<template>
  <div class="pt-4" :class="{ 'px-4': $vuetify.breakpoint.mdAndUp }">
    <div class="d-flex justify-space-between align-center">
      <Breadcrumbs
        :class="{ 'px-4 mt-2': $vuetify.breakpoint.smAndDown }"
        data="Đánh giá"
        headline="Đánh giá"
        :link="[{ text: 'Đánh giá' }]"
      />
      <v-btn elevation="0" color="primary" @click="openCreateDialog">
        <v-icon left>mdi-plus</v-icon>
        Tạo đánh giá
      </v-btn>
    </div>

    <v-card elevation="0" outlined class="mt-4">
      <v-tabs>
        <v-tab>Đánh giá</v-tab>
        <v-tab>Tiêu chí</v-tab>
        <v-tab>Mẫu đánh giá</v-tab>
        <v-tab>Thống kê</v-tab>
        <v-tab-item>
          <ListEvaluate ref="listEvaluate" />
        </v-tab-item>
        <v-tab-item>
          <ListCriteria />
        </v-tab-item>
        <v-tab-item>
          <ListEvaluateTemplate />
        </v-tab-item>
        <v-tab-item>
          <ReportEvaluate />
        </v-tab-item>
      </v-tabs>
    </v-card>
    <DialogCreateEvaluate ref="dialogCreateEvaluate" />
  </div>
</template>

<script>
import Breadcrumbs from '@/components/layout/Breadcrumbs.vue'
import ListCriteria from '@/modules/evaluate/ListCriteria.vue'
import ListEvaluate from '@/modules/evaluate/ListEvaluate.vue'
import ListEvaluateTemplate from '@/modules/evaluate/ListEvaluateTemplate.vue'
import ReportEvaluate from '@/modules/report-evaluate/ReportEvaluate.vue'
import DialogCreateEvaluate from '@/modules/evaluate/DialogCreateEvaluate.vue'

export default {
  components: {
    Breadcrumbs,
    ListCriteria,
    ListEvaluate,
    ListEvaluateTemplate,
    ReportEvaluate,
    DialogCreateEvaluate,
  },
  methods: {
    openCreateDialog() {
      this.$refs.dialogCreateEvaluate.openDialog()
    },
  },
}
</script>
